import React from 'react'

export type NavigationContextProps = {
  goToNextPage?: () => void
  goToPreviousPage?: () => void
  bypassStep?: () => void,
}

export const NavigationContext = React.createContext<NavigationContextProps>({})
